import React, { Component } from "react";
import Collapsible from "react-collapsible";
import { mergeStyleSets } from "office-ui-fabric-react/lib/Styling";
import Moment from "moment";

import { MomentDateFormat } from "../Vertical-Timeline/CustomFuntion";

import { Icon, Text, Link } from "office-ui-fabric-react";

import { TimelineItemDateText } from "../Vertical-Timeline/CustomFuntion";

const statusIconClass = mergeStyleSets({
  complete: [{ color: "#2ECC71", fontSize: "0.8em" }],
  open: [{ color: "gold", fontSize: "0.8em" }],
  close: [{ color: "red", fontSize: "0.8em" }],
  overdue: [{ color: "red", fontSize: "0.8em" }],
});

class AllTaskTl extends Component<{}, IState> {
  constructor(props: any) {
    super(props);

    this.state = {
      isLoaded: false,
      currentDate: new Date(),
      documentURL: "",
      allItems: [],
      otherOverdue: [],
      otherUpcoming: [],
      currentMonth: [],
    };
  }

  componentDidMount() {
    this.getAPI().then((apiRes) => {
      let api = JSON.parse(apiRes);
      this.setState(
        {
          documentURL: api.matterdetail,
        },
        () => {
          this._generateOtherOverdue(this.props.items);
          this._generateOtherUpcoming(this.props.items);
          this._generateCurrent(this.props.items);
          this.setState({
            allItems: this.props.items,
            isLoaded: true,
          });
        },
      );
    });
  }

  getAPI() {
    return new Promise((resolve) => {
      resolve(localStorage.getItem("api"));
    });
  }

  _getStatusIcon(status: string) {
    if (status === "Open") {
      return (
        <Icon iconName="StatusCircleInner" className={statusIconClass.open} />
      );
    } else if (status === "Complete") {
      return (
        <Icon
          iconName="StatusCircleInner"
          className={statusIconClass.complete}
        />
      );
    } else {
      return (
        <Icon iconName="StatusCircleInner" className={statusIconClass.close} />
      );
    }
  }

  _getOtherStatusIcon(status: string) {
    if (status === "Open") {
      return (
        <Icon
          iconName="StatusCircleInner"
          className={statusIconClass.overdue}
        />
      );
    } else {
      return (
        <Icon
          iconName="StatusCircleInner"
          className={statusIconClass.complete}
        />
      );
    }
  }

  _getCurrentStatusIcon(dueDate: any, status: string) {
    let itemDate = Moment(dueDate, "YYYY-MM-DD").toDate();
    if (status === "Complete") {
      return (
        <Icon
          iconName="StatusCircleInner"
          className={statusIconClass.complete}
        />
      );
    } else {
      if (itemDate < this.state.currentDate) {
        return (
          <Icon
            iconName="StatusCircleInner"
            className={statusIconClass.overdue}
          />
        );
      } else {
        return (
          <Icon iconName="StatusCircleInner" className={statusIconClass.open} />
        );
      }
    }
  }

  _generateOtherOverdue(currItem: any) {
    let tempOverdue = [];
    for (let c = 0; c < currItem.length; c++) {
      let itemDate = Moment(
        currItem[c].data.event.dueDate,
        "YYYY-MM-DD",
      ).toDate();

      if (itemDate < this.state.currentDate) {
        if (itemDate.getFullYear() === this.state.currentDate.getFullYear()) {
          if (itemDate.getMonth() != this.state.currentDate.getMonth()) {
            tempOverdue.push(currItem[c]);
          }
        } else {
          tempOverdue.push(currItem[c]);
        }
      }
    }

    this.setState({
      otherOverdue: tempOverdue,
    });
  }

  _generateCurrent(currItem: any) {
    let tempUpcoming = [];
    for (let c = 0; c < currItem.length; c++) {
      let itemDate = Moment(
        currItem[c].data.event.dueDate,
        "YYYY-MM-DD",
      ).toDate();
      if (
        itemDate.getMonth() === this.state.currentDate.getMonth() &&
        itemDate.getFullYear() === this.state.currentDate.getFullYear()
      ) {
        tempUpcoming.push(currItem[c]);
      }
    }
    this.setState({
      currentMonth: tempUpcoming,
    });
  }

  _generateOtherUpcoming(currItem: any) {
    let tempUpcoming = [];
    for (let c = 0; c < currItem.length; c++) {
      let itemDate = Moment(
        currItem[c].data.event.dueDate,
        "YYYY-MM-DD",
      ).toDate();
      if (itemDate > this.state.currentDate) {
        if (itemDate.getFullYear() === this.state.currentDate.getFullYear()) {
          if (itemDate.getMonth() != this.state.currentDate.getMonth()) {
            tempUpcoming.push(currItem[c]);
          }
        } else {
          tempUpcoming.push(currItem[c]);
        }
      }
    }

    this.setState({
      otherUpcoming: tempUpcoming,
    });
  }

  generateOtherOverdue() {
    this.state.otherOverdue.sort((a: any, b: any) => {
      return (
        parseInt(
          MomentDateFormat(a.data.event.dueDate).format("YYYYMMDD").toString(),
        ) -
        parseInt(
          MomentDateFormat(b.data.event.dueDate).format("YYYYMMDD").toString(),
        )
      );
    });
    return this.state.otherOverdue.map((items: any) => {
      return (
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm4 ms-md2 ms-lg1">
            {this._getOtherStatusIcon(items.data.event.status)}
          </div>
          <div className="ms-Grid-col ms-sm4 ms-md4 ms-lg3 task-date-label">
            <Text>{TimelineItemDateText(items.data.event.dueDate)}</Text>
          </div>
          <div className="ms-Grid-col ms-sm4 ms-md6 ms-lg8 table-data-description">
            <Collapsible
              key={items.id}
              className={"Collapsible-TimeLineItem"}
              contentOuterClassName={"Collapsible-Item"}
              trigger={items.data.event.task}
            >
              <Link
                type="submit"
                href={
                  this.state.documentURL +
                  "/Matter?matterCode=" +
                  items.data.matterCode +
                  "#/Workflow"
                }
                target="_blank"
              >
                {items.data.matterCode}
              </Link>
              <span>{" - "}</span> {items.data.description}
              <hr className="line-item" />
              {items.data.event.assignTo.length > 0 ? (
                <b className="assignToLabel">{"AssignTo: "} </b>
              ) : (
                ""
              )}
              {items.data.event.assignTo.map((assignto: any, index: any) => {
                return <i key={items.id + index}>{assignto.name}, </i>;
              })}
            </Collapsible>
          </div>
        </div>
      );
    });
  }

  generateCurrentMonth() {
    this.state.currentMonth.sort((a: any, b: any) => {
      return (
        parseInt(
          MomentDateFormat(a.data.event.dueDate).format("YYYYMMDD").toString(),
        ) -
        parseInt(
          MomentDateFormat(b.data.event.dueDate).format("YYYYMMDD").toString(),
        )
      );
    });
    return this.state.currentMonth.map((items: any) => {
      return (
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm4 ms-md2 ms-lg1">
            {this._getCurrentStatusIcon(
              items.data.event.dueDate,
              items.data.event.status,
            )}
            {/* {this._getStatusIcon(items.data.event.status)} */}
          </div>
          <div className="ms-Grid-col ms-sm4 ms-md4 ms-lg3 task-date-label">
            <Text>{TimelineItemDateText(items.data.event.dueDate)}</Text>
          </div>
          <div className="ms-Grid-col ms-sm4 ms-md6 ms-lg8 table-data-description">
            <Collapsible
              key={items.id}
              className={"Collapsible-TimeLineItem"}
              contentOuterClassName={"Collapsible-Item"}
              trigger={items.data.event.task}
            >
              <Link
                type="submit"
                href={
                  this.state.documentURL +
                  "/Matter?matterCode=" +
                  items.data.matterCode +
                  "#/Workflow"
                }
                target="_blank"
              >
                {items.data.matterCode}
              </Link>
              <span>{" - "}</span> {items.data.description}
              <hr className="line-item" />
              {items.data.event.assignTo.length > 0 ? (
                <b className="assignToLabel">{"AssignTo: "} </b>
              ) : (
                ""
              )}
              {items.data.event.assignTo.map((assignto: any, index: any) => {
                return <i key={items.id + index}>{assignto.name}, </i>;
              })}
            </Collapsible>
          </div>
        </div>
      );
    });
  }

  generateOtherUpcoming() {
    this.state.otherUpcoming.sort((a: any, b: any) => {
      return (
        parseInt(
          MomentDateFormat(a.data.event.dueDate).format("YYYYMMDD").toString(),
        ) -
        parseInt(
          MomentDateFormat(b.data.event.dueDate).format("YYYYMMDD").toString(),
        )
      );
    });
    return this.state.otherUpcoming.map((items: any) => {
      return (
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm4 ms-md2 ms-lg1">
            {this._getStatusIcon(items.data.event.status)}
          </div>
          <div className="ms-Grid-col ms-sm4 ms-md4 ms-lg3 task-date-label">
            <Text>{TimelineItemDateText(items.data.event.dueDate)}</Text>
          </div>
          <div className="ms-Grid-col ms-sm4 ms-md6 ms-lg8 table-data-description">
            <Collapsible
              key={items.id}
              className={"Collapsible-TimeLineItem"}
              contentOuterClassName={"Collapsible-Item"}
              trigger={items.data.event.task}
            >
              <Link
                type="submit"
                href={
                  this.state.documentURL +
                  "/Matter?matterCode=" +
                  items.data.matterCode +
                  "#/Workflow"
                }
                target="_blank"
              >
                {items.data.matterCode}
              </Link>
              <span>{" - "}</span> {items.data.description}
              <hr className="line-item" />
              {items.data.event.assignTo.length > 0 ? (
                <b className="assignToLabel">{"AssignTo: "} </b>
              ) : (
                ""
              )}
              {items.data.event.assignTo.map((assignto: any, index: any) => {
                return <i key={items.id + index}>{assignto.name}, </i>;
              })}
            </Collapsible>
          </div>
        </div>
      );
    });
  }

  generateAllItems() {
    return this.state.allItems.map((items: any) => {
      return (
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm4 ms-md2 ms-lg1">
            {this._getStatusIcon(items.data.event.status)}
          </div>
          <div className="ms-Grid-col ms-sm4 ms-md4 ms-lg3 task-date-label">
            <Text>{TimelineItemDateText(items.data.event.dueDate)}</Text>
          </div>
          <div className="ms-Grid-col ms-sm4 ms-md6 ms-lg8 table-data-description">
            <Collapsible
              key={items.id}
              className={"Collapsible-TimeLineItem"}
              trigger={items.data.event.task}
            >
              <br />
              <b>{items.data.matterCode}</b>
              <br />
              {items.data.description}
              <hr className="line-item" />
              {items.data.event.assignTo.length > 0 ? (
                <b>{"AssignTo :"} </b>
              ) : (
                ""
              )}
              {items.data.event.assignTo.map((assignto: any, index: any) => {
                return <i key={items.id + index}>{assignto.name}, </i>;
              })}
            </Collapsible>
          </div>
        </div>
      );
    });
  }

  public render() {
    const { isLoaded } = this.state;
    if (!isLoaded) return <div>Loading...</div>;
    else {
      const component = (
        <div className={"active-task-line"}>
          {/* {this.state.allItems} */}
          <Collapsible
            id="other-overdue"
            className="overdue-text"
            trigger={"Older (" + this.state.otherOverdue.length + ")"}
            triggerOpenedClassName="overdue-text-span"
            open={false}
          >
            <div className="ms-Grid task-grid" dir="ltr">
              {this.generateOtherOverdue()}
            </div>
          </Collapsible>
          <Collapsible
            id="current-month"
            className={"current-text-span ms-motion-slideDownIn"}
            trigger={
              Moment(this.state.currentDate).format("MMMM").toString() +
              "  (" +
              this.state.currentMonth.length +
              ")"
            }
            triggerOpenedClassName="current-text-span"
            open={true}
          >
            <div className="ms-Grid task-grid" dir="ltr">
              {this.generateCurrentMonth()}
            </div>
          </Collapsible>
          <Collapsible
            id="other-upcoming"
            className="upcoming-text ms-motion-slideDownIn"
            trigger={"Upcoming (" + this.state.otherUpcoming.length + ")"}
            triggerOpenedClassName="upcoming-text-span"
            open={false}
          >
            <div className="ms-Grid task-grid" dir="ltr">
              {this.generateOtherUpcoming()}
            </div>
          </Collapsible>
        </div>
      );

      return component;
    }
  }
}

export default AllTaskTl;
